import React from "react";
import "./Education.scss";
import {aboutSection} from "../../portfolio";

export default function Education() {
  if (!aboutSection.display) {
    return null;
  }

  const serviceIcons = {
    "Web Design": "fas fa-desktop",
    "AI Systems": "fas fa-brain",
    "Data Pipelines": "fas fa-seedling",
    Automation: "fas fa-briefcase"
  };
  const highlightedSubtitle = aboutSection.subTitle.replace(
    "your creative",
    "<em>your creative</em>"
  );

  return (
    <section className="education-section" id="education">
      <div className="about-page-inner">
        <div className="about-grid">
          <div className="about-media-block">
            <div className="about-quote-mark" aria-hidden="true">
              {"//"}
            </div>
            <div className="about-blue-slab" aria-hidden="true"></div>
            <figure className="about-portrait-frame">
              <img src={aboutSection.image} alt={aboutSection.imageAlt} />
              <figcaption>{aboutSection.imageCaption}</figcaption>
            </figure>
          </div>

          <div className="about-copy-block">
            <span className="section-label">{aboutSection.label}</span>
            <p className="about-kicker">My Experience:</p>
            <h1 className="education-heading">{aboutSection.title}</h1>
            <h2 dangerouslySetInnerHTML={{__html: highlightedSubtitle}}></h2>
            {aboutSection.description.map((paragraph, index) => (
              <p key={index} className="subTitle about-description">
                {paragraph}
              </p>
            ))}

            <div className="about-services">
              {aboutSection.services.map(service => (
                <div className="about-service" key={service}>
                  <i className={serviceIcons[service] || "fas fa-code"}></i>
                  <span>{service}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="about-facts-showcase">
          <div className="numbers-word" aria-hidden="true">
            Numbers
          </div>

          <div className="about-facts-copy">
            <h2>
              Some interesting <span>facts</span>
              <br />
              about me
            </h2>
            <p>{aboutSection.factsIntro}</p>
          </div>

          <div
            className="about-facts-image"
            style={{backgroundImage: `url(${aboutSection.factsImage})`}}
            aria-hidden="true"
          ></div>

          <div className="about-facts-counter-row">
            {aboutSection.facts.map(fact => (
              <div className="about-fact" key={fact.label}>
                <strong>{fact.count}</strong>
                <span>{fact.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
